<template>
  <b-card style="padding:40px;">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>

    <h5><b>STOCKOUT VIEW</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-name`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-date`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-date`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-comp_name`">Company Name</label>
          <b-form-input
            v-model="form.comp_name"
            :id="`input-comp_name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Outlet Category</label>
          <b-form-input
            v-model="form.outlet_category"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.suboutlet_cat">
        <b-form-group>
          <label :for="`input-role_code`">Sub Outlet Category</label>
          <b-form-input
            v-model="form.suboutlet_cat"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4" v-if="form.typeoutlet">
        <b-form-group>
          <label :for="`input-size`">Outlet Category Type</label>
          <b-form-input
            v-model="form.typeoutlet"
            id="input-horizontal"
            type="text"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.idno">
        <b-form-group>
          <label :for="`input-size`">Outlet ID Number</label>
          <b-form-input
            v-model="form.idno"
            id="input-horizontal"
            type="text"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Outlet Name</label>
          <b-form-input
            v-model="form.outlet_name"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Chiller</label>
          <b-form-radio-group
            v-model="form.chiller"
            :options="chiller"
            plain
            name="plain-inline"
            disabled
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="info"
            >Outlet Detail</b-button
          >
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Company Name</label>
                  <b-form-input
                    v-model="form.compName"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Account No.</label>
                  <b-form-input
                    v-model="form.accno"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Credit Term</label>
                  <b-form-input
                    v-model="form.credit_terms"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Fax No.</label>
                  <b-form-input
                    v-model="form.faxno"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Tel No.</label>
                  <b-form-input
                    v-model="form.telno"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Address 1</label>
                  <b-form-input
                    v-model="form.add1"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Address 2</label>
                  <b-form-input
                    v-model="form.add2"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Address 3</label>
                  <b-form-input
                    v-model="form.add3"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Billing Address 1</label>
                  <b-form-input
                    v-model="form.billAdd1"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Billing Address 2</label>
                  <b-form-input
                    v-model="form.billAdd2"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Billing Address 3</label>
                  <b-form-input
                    v-model="form.billAdd3"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Notes</label>
                  <b-form-textarea
                    v-model="form.notes"
                    class="input-new"
                    rows="3"
                    max-rows="6"
                    disabled
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <TableStockoutView
      :grand="grandP"
      :fields="fields"
      :items="items"
      :id="this.$route.query.id"
      :cat="this.$route.query.cat"
    />

    <h5><b>UPLOADED ATTACHMENTS</b></h5>

    <b-table
      head-variant="dark"
      striped
      hover
      bordered
      :items="files"
      :fields="table.files"
      show-empty
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(action)="data">
        <b-button variant="primary" size="sm" @click="openAttch(data.item.path)"
          >Open Attachment</b-button
        >
        &nbsp;&nbsp;&nbsp;
        <b-button
          variant="primary"
          size="sm"
          @click="onDelete(data.item.generate_doc_id)"
          >DELETE</b-button
        >
      </template>
    </b-table>

    <b-row>
      <b-col align="right">
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickInvoice">
          DOWNLOAD INVOICE
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button
          variant="primary"
          size="sm"
          v-if="accLvl != '1'"
          @click="openModal"
        >
          UPLOAD INVOICE
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button
          variant="primary"
          size="sm"
          v-if="accLvl != '1'"
          @click="onClickChange"
        >
          Edit
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button variant="danger" size="sm" @click="onClickDeleteStock">
          Delete
        </b-button>
      </b-col>
    </b-row>

    <b-modal id="upload-invoice" title="Upload Invoice">
      <b-col md="12" style="padding:50px;">
        <center>
          <b-row>
            <b-col md="12">
              <b-form-file v-model="image" class="mt-3" plain></b-form-file>
            </b-col>
          </b-row>
        </center>
      </b-col>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="onClickUpload()">
          Upload
        </b-button>
        <b-button variant="primary" size="sm" @click="close()">
          Close
        </b-button>
      </template>
    </b-modal>

    <b-modal id="delete-invoice" title="Delete Confirmation">
      <p>
        <b>Are you sure you want to delete ?</b>
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>
    <b-modal id="delete-stock" title="Delete Confirmation">
      <p>
        <b>Are you sure you want to delete ?</b>
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteStockConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import TableStockoutView from "@/table/user/stockout/TableStockoutView";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import Failed from "@/pages/Notifications/Failed";
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      grandP: "",
      items: [],

      isLoading: false,
      fullPage: true,

      form: {
        stock_id: null,
        name: "",
        date: "",
        comp_name: "",
        role: "",
        outlet_category: "",
        outlet_name: "",
        type: "",
        chiller: "",
        suboutlet_cat: "",
        faxno: "",
        telno: "",
        add1: "",
        add2: "",
        add3: "",
        notes: "",
        billAdd1: "",
        billAdd2: "",
        billAdd3: "",
        compName: "",
        credit_terms: "",
        accno: ""
      },

      // Chiller
      chiller: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" }
      ],

      image: "",

      files: [],

      table: {
        files: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: false
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "qtyType",
          sortable: true
        },
        {
          label: "Price",
          key: "price",
          sortable: false
        },
        {
          label: "Total Price",
          key: "totalPrice",
          sortable: false
        }
      ],
      accLvl: null
    };
  },

  created() {
    this.accLvl = parseInt(this.$store.getters.getAccessLevel);

    this.showStockout();
    this.getFiles();
  },
  methods: {
    showStockout() {
      this.isLoading = true;
      this.$store
        .dispatch("showStockout", {
          stock_id: this.$route.query.id
        })
        .then(res => {
          let price = 0;
          if (res.data.response.code === 100) {
            this.isLoading = false;
            let outletName;
            if (res.data.data.outlet !== null) {
              outletName = res.data.data.outlet.name;
            }

            if (res.data.data.suboutlet.name) {
              this.form.suboutlet_cat = res.data.data.suboutlet.name;
            }
            if (res.data.data.suboutlettype.name) {
              this.form.typeoutlet = res.data.data.suboutlettype.name;
            }

            this.form.id = this.$route.query.id;
            this.form.idno = res.data.data.idno;
            this.form.name = res.data.data.userdetails.name;
            this.form.date = moment(res.data.data.date).format("DD/MM/YYYY");
            this.form.comp_name = res.data.data.userdetails.company;
            this.form.role = res.data.data.userdetails.role_details.desc;
            this.form.outlet_category = outletName;
            this.form.chiller = res.data.data.chiller;
            this.form.outlet_name = res.data.data.outlethistory.outlet_name;
            this.form.faxno = res.data.data.outlethistory.faxno;
            this.form.telno = res.data.data.outlethistory.telno;
            this.form.add1 = res.data.data.outlethistory.add1;
            this.form.add2 = res.data.data.outlethistory.add2;
            this.form.add3 = res.data.data.outlethistory.add3;
            this.form.notes = res.data.data.outlethistory.notes;
            this.form.billAdd1 = res.data.data.company_add1;
            this.form.billAdd2 = res.data.data.company_add2;
            this.form.billAdd3 = res.data.data.company_add3;
            this.form.compName = res.data.data.company_name;
            this.form.credit_terms = res.data.data.credit_terms;
            this.form.accno = res.data.data.accno;

            res.data.data.pro_stock.forEach(element => {
              let defPrice = parseFloat(element.total_price_pu);
              price += defPrice;
              this.items.push({
                name: element.product.name,
                sku: element.product_id,
                quantity: element.quantity,
                qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn",
                price: element.price,
                totalPrice: element.total_price_pu
              });
            });
            this.grandP = price;
          }
        });
    },
    onClickInvoice() {
      this.isLoading = true;
      this.$store
        .dispatch("getInvoice", {
          category: this.$route.query.cat,
          stock_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.isLoading = false;
            // window.open(`https://azizazri.com/${res.data.data.path}`, "_blank");
            window.open(
              `${process.env.VUE_APP_BASE_URL}/${res.data.data.path}`,
              "_blank"
            );
          } else {
            this.isLoading = false;
          }
        });
    },

    openAttch(path) {
      window.open(`${process.env.VUE_APP_BASE_URL}/${path}`, "_blank");
      // window.open(`https://azizazri.com/${path}`, "_blank");
    },
    onDelete(param) {
      this.deleteIndex = param;
      this.$bvModal.show("delete-invoice");
    },
    onClickDeleteConfirm() {
      this.$store.dispatch("deleteInvoice", this.deleteIndex).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("delete-invoice");
          this.getFiles();
        }
      });
    },
    onClickDeleteStock() {
      this.$bvModal.show("delete-stock");
    },
    onClickDeleteStockConfirm() {
      this.$store.dispatch("deleteStockout", this.form.id).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("delete-stock");
          this.onClickBack();
        }
      });
    },
    onClickChange() {
      this.$router.push({
        path: `stockout_user_create?stockid=${this.$route.query.id}&type=update`
      });
    },

    getFiles() {
      this.$store.dispatch("getInvoiceList", this.$route.query.id).then(res => {
        if (res.data.response.code === 100) {
          this.files = [];
          res.data.data.forEach(item => {
            this.files.push({
              generate_doc_id: item.generate_doc_id,
              name: item.name,
              path: item.path
            });
          });
        }
      });
    },
    openModal() {
      this.$bvModal.show("upload-invoice");
    },

    onClickUpload() {
      let form = new FormData();
      form.set("any_id", this.$route.query.id);
      form.set("category", 1);
      if (this.form.image !== null) {
        form.set("image", this.image);
      }
      this.$store.dispatch("uploadInvoice", form).then(res => {
        if (res.data.response.code === 1) {
          this.$notify({
            component: NotificationTemplate,
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
          this.$bvModal.hide("upload-invoice");
          this.getFiles();
        } else {
          this.$notify({
            component: Failed,
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
          this.getFiles();
        }
      });
    },
    onClickBack() {
      if (this.accLvl === 1) {
        if (this.$route.query.type === "sub") {
          this.$router.push({
            path: `home_dealer_admin?state=${this.$route.query.state}&stockist_id=${this.$route.query.upline}&tab=2&page=${this.$route.query.page}&filter=${this.$route.query.filter}&date=${this.$route.query.date}&name=${this.$route.query.name}&outlet_name=${this.$route.query.outlet_name}&email=${this.$route.query.email}`
          });
        } else {
          this.$router.push({
            path: `/stockout?state=${this.$route.query.state}&upline=${this.$route.query.upline}&year=${this.$route.query.year}&month=${this.$route.query.month}&page=${this.$route.query.page}&filter=${this.$route.query.filter}&date=${this.$route.query.date}&name=${this.$route.query.name}&outlet_name=${this.$route.query.outlet_name}`
          });
        }
      } else {
        if (
          this.$route.query.from !== undefined &&
          this.$route.query.from === "created"
        ) {
          this.$router.push({
            path: `stockout_user`
          });
        } else {
          if (this.$route.query.filter !== undefined) {
            if (this.$route.query.type === "sub") {
              this.$router.push({
                path: `sub_dealer_user?tab=2&page=${this.$route.query.page}&filter=${this.$route.query.filter}&date=${this.$route.query.date}&name=${this.$route.query.name}&outlet_name=${this.$route.query.outlet_name}&email=${this.$route.query.email}`
              });
            } else {
              this.$router.push({
                path: `stockout_user?page=${this.$route.query.page}&filter=${this.$route.query.filter}&date=${this.$route.query.date}&main_outlet_name=${this.$route.query.main_outlet_name}&outlet_name=${this.$route.query.outlet_name}`
              });
            }
          } else {
            this.$router.go(-1);
          }
        }
      }
    }
  },
  components: {
    TableStockoutView,
    Loading
  }
};
</script>
<style lang="css" scoped></style>
